import get from 'lodash/get'
import Helpers from './helpers'
import Utils from './entity-mapping'
const ENTITIES_DATE = ['laboratory', 'vitals', 'observation']
const END_DATE_ENTITIES = ['allergy', 'medication', 'diagnosis'] ///show end date of these entities

export default {
  formatCardTitle(entity, entityType) {
    const productEntities = ['medication', 'immunization']
    let cardTitle = ''
    if (productEntities.includes(entityType)) {
      ///Get name of the product in case of medication/immunization entity
      cardTitle = get(entity, 'product.name', '')
    } else if (entityType === 'diagnosis') {
      cardTitle = get(entity, 'codes.originalText.content', '')
    } else {
      cardTitle = get(entity, 'codes[0].name', '')
      if (cardTitle && ENTITIES_DATE.includes(entityType)) {
        cardTitle += ' ' + this.formatComponents(entity, '')
      }
    }
    return cardTitle
  },
  formatIngredients(entity) {
    let ingredients = get(entity, 'product.ingredients', [])
    let formatted = ''
    for (let i of ingredients) {
      if (i.product) {
        formatted += i.product + ' '
      }
    }
    return formatted
  },
  formatDate(entity) {
    let date = ''
    let contextDates = get(entity, 'contextDates', '')
    if (contextDates.start) {
      date = Helpers.ciiFormatDate(contextDates.start.date)
    } else if (contextDates.event) {
      date = Helpers.ciiFormatDate(contextDates.event.date)
    } else {
      date = Helpers.ciiFormatDate(entity.eventDate)
    }
    return date
  },
  formatEndDate(entity, entityType) {
    if (END_DATE_ENTITIES.includes(entityType)) {
      return Helpers.ciiFormatDate(get(entity, 'contextDates.end.date', ''))
    }
    return ''
  },
  formatDateLabel(entityType) {
    let dateLabel = 'Date'
    for (let key in Utils.entityMappings) {
      if (key.includes(entityType) && entityType) {
        dateLabel = Utils.entityMappings[key][1] ///get date label
        break
      }
    }
    return dateLabel
  },
  formatPractitioner(entity, entityType) {
    let practitioner = ''
    if (entity.practitioner) {
      practitioner = get(entity, 'practitioner.data', '')
    } else if (entity.performers) {
      const performer = entity.performers[0]
      if (performer.person && performer.person.name) {
        practitioner = get(entity, 'performers[0].person.name', '')
      } else if (
        performer.organization &&
        performer.organization.name &&
        entityType === 'procedure'
      ) {
        practitioner = get(entity, 'performers[0].organization.name', '')
      }
    } else if (entity.request) {
      practitioner = get(entity, 'request.requester.personName.fullName', '')
    } else if (entity.asserter) {
      practitioner = get(entity, 'asserter.person.name', '')
    }
    return practitioner
  },
  formatValues(entity) {
    let getValues = ''
    const valueUnits = get(entity, 'valueUnits.values[0]', '')
    if (valueUnits.value) {
      getValues = valueUnits.value
    } else if (valueUnits.code && valueUnits.code.name) {
      getValues = valueUnits.code.name
    } else {
      getValues = get(entity, 'valueUnits.rawValues[0].value', '')
    }
    getValues += ' ' + this.formatComponents(entity, 'values')
    return getValues.trim()
  },
  formatNotes(entity) {
    let notes = get(entity, 'notes', [])
    let formatted = ''
    for (let i of notes) {
      formatted += i.value + ' '
    }
    return formatted
  },
  formatReferenceRange(entity) {
    let getReferenceRange = ''
    const referenceRanges = get(entity, 'valueUnits.referenceRanges', [])
    const components = get(entity, 'components', [])
    if (referenceRanges) {
      getReferenceRange = get(entity, 'valueUnits.referenceRanges[0].text', '')
    }
    if (components) {
      for (let i of components) {
        if (i.valueUnits) {
          getReferenceRange += get(i, 'valueUnits.referenceRanges[0].text', '') + ' '
        }
      }
    }
    if (entity.valueUnits && entity.valueUnits.range) {
      getReferenceRange += get(entity, 'valueUnits.range', '')
    }
    return getReferenceRange
  },
  formatInterpretation(entity, entityType) {
    let interpretation = ''
    if (ENTITIES_DATE.includes(entityType)) {
      const interprerations = get(entity, 'valueUnits.interprerations', [])
      if (interprerations) {
        for (let i of interprerations) {
          interpretation += i.text + ' '
        }
      } else {
        const codes = get(this.entity, 'codes', [])
        for (let i of codes) {
          if (i.name && i.code) {
            interpretation += i.name + ' | ' + i.code
          }
        }
      }
    }
    return interpretation
  },
  formatUnits(entity) {
    let units = ''
    const valueUnits = get(entity, 'valueUnits', '')
    const code = get(valueUnits, 'values[0].code.code', '')
    if (valueUnits) {
      if (valueUnits.unit && valueUnits.unit.value) {
        units = get(entity, 'valueUnits.unit.value', '')
      } else if (valueUnits.unit && valueUnits.unit.code) {
        units = get(entity, 'valueUnits.unit.code', '')
      } else if (code) {
        units = code
      } else {
        units = get(entity, 'valueUnits.rawValues[0].value', '')
      }
    }
    units += ' ' + this.formatComponents(entity, 'units')
    return units.trim()
  },
  formatReactions(entity) {
    let reactions = get(entity, 'reactions', [])
    let formatted = ''
    for (let i of reactions) {
      if (i.description) {
        formatted += i.description + ' '
      }
    }
    return formatted
  },
  formatSeverityReactions(entity) {
    let severityReactions = get(entity, 'reactions', [])
    let formatted = ''
    for (let i of severityReactions) {
      formatted += get(i.severity, 'codes[0].name', '') + ' '
    }
    return formatted
  },
  getEntityLabel(entityType) {
    let getEntityLabel = ''
    for (let key in Utils.entityMappings) {
      if (key.includes(entityType) && entityType) {
        getEntityLabel = Utils.entityMappings[key][0] + ' ' ///get entity label
        break
      }
    }
    return getEntityLabel
  },
  formatComponents(entity, item) {
    let formatComponent = ''
    const components = get(entity, 'components', [])
    for (let key in components) {
      if (item === 'values') {
        /// Get value from component array
        const values = get(key, 'valueUnits.values[0].value', '')
        const rawValues = get(key, ' valueUnits.rawValues[0].value', '')
        if (values) {
          formatComponent += values + ' '
        } else if (rawValues) {
          formatComponent += rawValues + ' '
        }
      } else if (item === 'units') {
        /// Get units from component array
        const unit = get(key, 'valueUnit.unit.code.code', '')
        const rawUnits = get(key, ' valueUnits.rawUnit.value', '')

        if (unit) {
          formatComponent += unit + ' '
        } else if (rawUnits) {
          formatComponent += rawUnits + ' '
        }
      } else {
        if (key.code && key.code.codes) {
          formatComponent = key.code.codes[0].name + ' '
        }
      }
    }
    return formatComponent
  }
}
